/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_ViewInputs */

const en_table_view = /** @type {(inputs: Table_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const pt_br2_table_view = /** @type {(inputs: Table_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizar`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Table_ViewInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_view = /** @type {((inputs?: Table_ViewInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_ViewInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_view(inputs)
	return pt_br2_table_view(inputs)
});